import { RenewableSystemType } from '@brokerportal/common/enums';

export interface SystemTypeOption {
    value: RenewableSystemType;
    label: string;
    icon: string; // Assuming MatIcon is used for icons
}

export const SOLAR_OPTION: SystemTypeOption = {
    value: RenewableSystemType.Solar,
    label: 'Solar panels',
    icon: 'wb_sunny'
};
export const BATTERY_OPTION: SystemTypeOption = {
    value: RenewableSystemType.Battery,
    label: 'Battery system',
    icon: 'battery_charging_full'
};

export const STANDARD_SYSTEM_TYPES: SystemTypeOption[] = [
    SOLAR_OPTION,
    BATTERY_OPTION,
    { value: RenewableSystemType.HeatPump, label: 'Heat pump', icon: 'local_fire_department' },
    { value: RenewableSystemType.SolarHotWater, label: 'Solar hot water', icon: 'shower' },
    { value: RenewableSystemType.EvCharger, label: 'EV charger', icon: 'electrical_services' }
];

export const HEUF_SYSTEM_TYPES: SystemTypeOption[] = [
    { value: RenewableSystemType.Aircon, label: 'Aircon', icon: 'ac_unit' },
    // { value: RenewableSystemType.SmartMeter, label: 'Smart Meter', icon: 'offline_bolt' },
    // { value: RenewableSystemType.PoolPump, label: 'Pool Pump', icon: 'pool' },
    // {
    //     value: RenewableSystemType.EnergyMonitoringSystem,
    //     label: 'Energy Monitoring System',
    //     icon: 'monitor_heart'
    // },
    {
        value: RenewableSystemType.Insulation,
        label: 'Insulation',
        icon: 'ac_unit'
    }
    // { value: RenewableSystemType.InductionCooktop, label: 'Induction Cooktop', icon: 'countertops' }
];

/**
 * Full HESLP (NSW Home Energy Saver Loan) equipment catalogue using ESC Schedule 2 Part A wording.
 * Consumers narrow it with `allowedSystemTypes` according to the per-type feature flags.
 */
export const HESLP_SYSTEM_TYPES: SystemTypeOption[] = [
    SOLAR_OPTION,
    BATTERY_OPTION,
    { value: RenewableSystemType.Aircon, label: 'Reverse-cycle air conditioner', icon: 'ac_unit' },
    { value: RenewableSystemType.HeatPump, label: 'Heat pump water heater', icon: 'local_fire_department' },
    { value: RenewableSystemType.CeilingFan, label: 'AC or DC ceiling fan', icon: 'toys' }
];
